import React from "react";
import { Phone, Mail, MapPin, Instagram, Facebook, MessageCircle } from "lucide-react";
import { LOGO_URL, PHONE, PHONE_RAW, EMAIL, navLinks, services, WHATSAPP_BASE } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[#122b45] text-white pt-16 pb-20 lg:pb-8">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="reveal">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Nanhe Kadam" className="h-28 w-28 object-contain" />
              <div>
                <div className="font-serif text-2xl">Nanhe Kadam</div>
                <div className="text-xs text-white/60">Therapy Centre · Patna</div>
              </div>
            </div>
            <p className="mt-5 text-sm text-white/70 leading-relaxed">
              Compassionate, child-first pediatric therapy — helping every little step turn into a big breakthrough.
            </p>
            <div className="mt-5 flex gap-3">
              <a href={WHATSAPP_BASE} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#25d366] flex items-center justify-center transition">
                <MessageCircle className="w-4 h-4" />
              </a>
              <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#ee6c4d] flex items-center justify-center transition">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#ee6c4d] flex items-center justify-center transition">
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.18em] text-white/80">Explore</h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-white/70 hover:text-[#ee6c4d] transition">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.18em] text-white/80">Services</h4>
            <ul className="mt-4 space-y-2.5">
              {services.slice(0, 6).map((s) => (
                <li key={s.title}>
                  <a href="#services" className="text-sm text-white/70 hover:text-[#ee6c4d] transition">{s.title}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.18em] text-white/80">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-3">
                <span className="relative inline-flex w-7 h-7 rounded-full bg-[#ee6c4d]/15 items-center justify-center shrink-0">
                  <span className="absolute inset-0 rounded-full bg-[#ee6c4d]/40 animate-ping" />
                  <Phone className="w-3.5 h-3.5 text-[#ee6c4d] phone-ring relative" />
                </span>
                <a href={`tel:${PHONE_RAW}`} className="hover:text-white pt-1">{PHONE}</a>
              </li>
              <li className="flex items-start gap-3">
                <span className="relative inline-flex w-7 h-7 rounded-full bg-green-400/15 items-center justify-center shrink-0">
                  <span className="absolute inset-0 rounded-full bg-green-400/30 animate-ping" style={{animationDelay: "0.4s"}} />
                  <Mail className="w-3.5 h-3.5 text-green-300 relative mail-wiggle" />
                </span>
                <a href={`mailto:${EMAIL}`} className="hover:text-white break-all pt-1">{EMAIL}</a>
              </li>
              <li className="flex items-start gap-3">
                <span className="inline-flex w-7 h-7 rounded-full bg-white/10 items-center justify-center shrink-0">
                  <MapPin className="w-3.5 h-3.5 text-[#ee6c4d]" />
                </span>
                <span className="pt-1">Patna, Bihar, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Nanhe Kadam Therapy Centre. All rights reserved.</div>
          <div>Made with care in Patna, Bihar.</div>
        </div>
      </div>
    </footer>
  );
}
